<h1 class="mb-5">Users</h1>

<div class="row mb-3">
  <div class="col p-0">
    <div class="form-group">
      <input type="text" class="form-control" placeholder="Search for user ..." [(ngModel)]="searchTerm" (input)="filterOptions()">
    </div>
  </div>
</div>

<div class="row">
  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col">Full Name</th>
        <th scope="col">Email</th>
        <th scope="col">Phone Number</th>
        <th scope="col">Role</th>
        <th scope="col">Company</th>
        <th scope="col">Last login</th>
        <th scope="col">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let user of filteredUsers">
        <td>{{ user.fullName }}</td>
        <td>{{ user.email }}</td>
        <td>{{ user.phoneNumber || 'N/A' }}</td>
        <td>{{ user.role }}</td>
        
        <td>
          <a [routerLink]="['/homeAdmin/v2/companies', user.companyId]">
            {{ user.companyName || 'View Company' }}
          </a>
        </td>
        <td>{{ user.lastLogin || 'N/A' }}</td>

        <td class="text-center align-middle">
          <button class="btn btn-sm btn-primary"
            [routerLink]="['/homeAdmin/v2/companies', user.companyId, 'users', user.id, 'edit']">
            Edit
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
